/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'EYEWASH_STATIONS_AND_SHOWERS_ARE_CLEARLY_IDENTIFIABLE',
              'EYEWASH_STATIONS_AND_SHOWERS_ARE_EASY_TO_ACCESS',
              'EYEWASH_STATIONS_AND_SHOWERS_ARE_CLEAR_OF_CLUTTER_DEBRIS',
              'EYEWASH_STATIONS_AND_SHOWERS_USE_POTABLE_WATER_AT_THE_RIGHT_TEM',
              'EYEWASH_STATIONS_AND_SHOWERS_ARE_REGULARLY_INSPECTED',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_7: valueSchema,
  },
}
